<template>
  <router-link :to="detailRoute" class="rank-tile">
    <span class="rank">{{ rank }}</span>
    <div class="logo">
      <img :src="token.image" :alt="token.name" loading="lazy" @error="onImgError" />
    </div>
    <div class="identity">
      <p class="name">{{ token.name }}</p>
      <p class="type">{{ typeLabel }}</p>
    </div>
    <span v-if="!commodity" class="yield">{{ yieldValue }}%</span>
  </router-link>
</template>

<script>
import * as ex from "@/utils/exchange.js";
import { listingView } from "@/utils/trade-view";

export default {
  name: "RankTile",
  props: {
    token: { type: Object, required: true },
    rank: { type: Number, required: true },
  },
  computed: {
    // The deal type as every other list names it.
    typeLabel() {
      return listingView(this.token).badge.label;
    },
    commodity() {
      return ex.isCommodity(this.token);
    },
    yieldValue() {
      return ex.listingYield(this.token);
    },
    detailRoute() {
      return {
        name: "TokenOverview",
        params: { symbol: this.token.symbol, id: this.token._id || this.token.id },
      };
    },
  },
  methods: {
    onImgError(e) {
      e.target.src = require("@/assets/img/token-icon.svg");
    },
  },
};
</script>

<style lang="scss" scoped>
.rank-tile {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 11px;
  padding: 14px 16px;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    border-color: #4d84ff;
    box-shadow: 0 4px 20px rgba(77, 132, 255, 0.12);
    transform: translateY(-2px);
  }
}

.rank {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #f2994a;
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

.logo {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  background: #f8fafc;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.identity {
  flex: 1;
  min-width: 0;
}

.name {
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.type {
  margin: 1px 0 0;
  font-size: 13px;
  color: #64748b;
}

.yield {
  font-size: 16px;
  font-weight: 500;
  color: #4d84ff;
  flex-shrink: 0;
}
</style>
